import { Card, Typography } from "antd";
import "./BenefitsCard.scss";

const { Title, Text } = Typography;

export default function BenefitsCard({
  title,
  icon,
  impactPoints,
  token,
  borderColor,
}) {
  const shadowColor = borderColor || token?.colorPrimary;

  return (
    <Card
      className="aboutBenefits-card"
      hoverable
      style={{
        border: "none",
        backgroundColor: token?.Card?.colorBgCard,
        borderLeft: `4px solid ${shadowColor}`,
        "--shadow-color": shadowColor,
      }}>
      <div className="aboutBenefits-card__content">
        <Title
          level={3}
          style={{ color: borderColor || token?.colorPrimary, margin: 0 }}>
          {icon && <span style={{ marginRight: "8px" }}>{icon}</span>}
          {title || "Key Benefits"}
        </Title>
        <div className="aboutBenefits-card__points">
          {impactPoints.map((point, index) => (
            <div key={index} className="aboutBenefits-card__point">
              <span className="aboutBenefits-card__point__icon">
                {point?.icon}
              </span>
              <Text className="aboutBenefits-card__point__text">
                {point?.text}
              </Text>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
}
